import { fetchEventSource } from '@microsoft/fetch-event-source';
import { getApiBase } from './http';
import { getAuthToken } from '@/auth/token';
export function streamPost(path, body, handlers) {
    const ctrl = new AbortController();
    void (async () => {
        const token = await getAuthToken();
        await fetchEventSource(`${getApiBase()}/api${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'text/event-stream',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(body),
            signal: ctrl.signal,
            openWhenHidden: true,
            onmessage(ev) {
                let data = ev.data;
                try {
                    data = JSON.parse(ev.data);
                }
                catch { /* leave as raw */ }
                switch (ev.event) {
                    case 'token':
                        handlers.onToken?.(data?.text ?? '');
                        return;
                    case 'status':
                        handlers.onStatus?.(data?.phase ?? 'thinking');
                        return;
                    case 'done':
                        handlers.onDone?.(data);
                        ctrl.abort();
                        return;
                    case 'error':
                        handlers.onError?.(data?.detail ?? 'unknown error');
                        ctrl.abort();
                        return;
                }
            },
            onerror(err) {
                handlers.onError?.(err.message);
                throw err; // stop retrying
            },
        });
    })().catch(() => { });
    return ctrl;
}
